<template>
  <div class="min-h-[408px] flex items-center justify-center loader">
    <div
      class="border-gray-300 h-14 sm:h-20 w-14 sm:w-20 animate-spin rounded-full border-8 border-t-vivid-purple item"
    ></div>
  </div>
</template>